import React, { useEffect, useState, useMemo } from "react";
import { Alert, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Button, Chip } from "@mui/material";
import { useGetAdminUserPermisos } from "../../hooks/AdministracionUserPermisos/getAdminUserPermisos";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import AddAdminPermiso from "../../components/administracionUsuarios/modalesAdminUser/addAdminPermiso";
import UpdateAdminPermiso from "../../components/administracionUsuarios/modalesAdminUser/updateAdminPermiso";
import DeleteAdminPermiso from "../../components/administracionUsuarios/modalesAdminUser/deleteAdminPermiso";

export default function PermisosView() {

    const {
        permisos,
        loading,
        error,
        obtenerPermisos,
    } = useGetAdminUserPermisos();

    //agrupacion de informacion  para desplegables
    const permisosAgrupados = permisos.reduce((acc: any, permiso: any) => {

        if (!acc[permiso.sufijo]) {
            acc[permiso.sufijo] = [];
        }

        acc[permiso.sufijo].push(permiso);

        return acc;

    }, {});


    useEffect(() => {
        obtenerPermisos();
    }, []);

    const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedPermiso, setSelectedPermiso] = useState<any>(null);
    const [gruposAbiertos, setGruposAbiertos] = useState<Record<string, boolean>>({});


    // Agregar permiso
    const [openAddPermiso, setOpenAddPermiso] = useState(false);

    const handleOpenAddPermiso = () => {
        setOpenAddPermiso(true);
    };

    const handleCloseAddPermiso = () => {
        setOpenAddPermiso(false);
    };

    const handlePermisoCreated = async () => {
        await obtenerPermisos();
    };

    // Actualizar  permiso
    const [openUpdatePermiso, setOpenUpdatePermiso] = useState(false);

    const handleOpenUpdatePermiso = () => {
        setOpenUpdatePermiso(true);
    };

    const handleCloseUpdatePermiso = () => {
        setOpenUpdatePermiso(false);
        setSelectedPermiso(null);
    };

    const handlePermisoUpdated = async () => {

        await obtenerPermisos();

    };

    // Eliminar permiso
    const [openDeletePermiso, setOpenDeletePermiso] = useState(false);

    const handleOpenDeletePermiso = () => {
        setOpenDeletePermiso(true);
    };

    const handleCloseDeletePermiso = () => {
        setOpenDeletePermiso(false);
        setSelectedPermiso(null);
    };

    const handlePermisoDeleted = async () => {

        await obtenerPermisos();

    };

    // busqueda filtro 
    const [busqueda, setBusqueda] = useState("");

    const handleOpenMenu = (
        event: React.MouseEvent<HTMLElement>,
        permiso: any
    ) => {
        setMenuAnchorEl(event.currentTarget);
        setSelectedPermiso(permiso);
    };

    const handleCloseMenu = () => {
        setMenuAnchorEl(null);
    };

    const handleEditar = () => {
        handleCloseMenu();
        handleOpenUpdatePermiso();
    };

    const handleEliminar = () => {
        handleCloseMenu();
        handleOpenDeletePermiso();
    };

    //desplegable con registros 
    const toggleGrupo = (grupo: string) => {
        setGruposAbiertos((prev) => ({
            ...prev,
            [grupo]: !prev[grupo],
        }));
    };


    const permisosAgrupadosFiltrados = useMemo(() => {

        const texto = busqueda.trim().toUpperCase();

        if (!texto) {
            return permisosAgrupados;
        }

        const resultado: Record<string, any[]> = {};

        Object.entries(permisosAgrupados).forEach(
            ([grupo, lista]: any) => {

                const coincidencias = lista.filter((permiso: any) =>
                    permiso.nombre.toUpperCase().includes(texto)
                );

                if (coincidencias.length > 0) {
                    resultado[grupo] = coincidencias;
                }

            }
        );

        return resultado;

    }, [permisosAgrupados, busqueda]);

    if (loading) {
        return <CircularProgress />;
    }

    if (error) {
        return (
            <Alert severity="error">
                {error}
            </Alert>
        );
    }

    return (

        <Box>

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
            >
                <TextField
                    size="small"
                    placeholder="Buscar por nombre..."
                    value={busqueda}
                    onChange={(e) => setBusqueda(e.target.value)}
                    sx={{ width: 320 }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                />
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleOpenAddPermiso}
                    sx={{
                        bgcolor: "#1976d2",
                        color: "#fff",
                        textTransform: "none",
                        fontWeight: 600,
                        borderRadius: 2,
                        "&:hover": {
                            bgcolor: "#1565c0",
                        },
                    }}
                >
                    Agregar Permiso
                </Button>

            </Box>

            <TableContainer component={Paper}>
                <Table>

                    <TableBody>

                        {Object.entries(permisosAgrupadosFiltrados).map(([grupo, lista]: any) => (

                            <React.Fragment key={grupo}>

                                {/* Cabecera del grupo */}
                                <TableRow
                                    sx={{
                                        backgroundColor: "#F5F5F5",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => toggleGrupo(grupo)}
                                >
                                    <TableCell
                                        colSpan={5}
                                        sx={{
                                            fontWeight: "bold",
                                            fontSize: 15,
                                        }}
                                    >
                                        {gruposAbiertos[grupo] ? (
                                            <KeyboardArrowDownIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                                        ) : (
                                            <KeyboardArrowRightIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                                        )}

                                        {grupo} ({lista.length})
                                    </TableCell>
                                </TableRow>

                                {/* si se abre desplegable mostra informacion del registro en la tabla depenndiendo el sufijo */}
                                {gruposAbiertos[grupo] && (
                                    <>

                                        {/* Encabezado del grupo */}
                                        <TableRow
                                            sx={{
                                                backgroundColor: "#FAFAFA",
                                            }}
                                        >
                                            <TableCell sx={{ fontWeight: "bold" }}>
                                                Nombre
                                            </TableCell>

                                            <TableCell sx={{ fontWeight: "bold" }}>
                                                Descripción
                                            </TableCell>

                                            <TableCell sx={{ fontWeight: "bold" }}>
                                                Estatus
                                            </TableCell>

                                            <TableCell
                                                align="center"
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                Acciones
                                            </TableCell>
                                        </TableRow>

                                        {/* Registros */}
                                        {lista.map((permiso: any) => (

                                            <TableRow key={permiso.id}>

                                                <TableCell>
                                                    {permiso.nombre}
                                                </TableCell>

                                                <TableCell>
                                                    {permiso.descripcion}
                                                </TableCell>

                                                <TableCell>
                                                    <Chip
                                                        label={Number(permiso.estatus) === 1 ? "Activo" : "Inactivo"}
                                                        color={Number(permiso.estatus) === 1 ? "success" : "error"}
                                                        size="small"
                                                        sx={{
                                                            fontWeight: 600,
                                                            minWidth: 80,
                                                        }}
                                                    />
                                                </TableCell>

                                                <TableCell align="center">

                                                    <IconButton
                                                        size="small"
                                                        onClick={(event) =>
                                                            handleOpenMenu(event, permiso)
                                                        }
                                                    >
                                                        <MoreVertIcon />
                                                    </IconButton>

                                                </TableCell>

                                            </TableRow>

                                        ))}

                                    </>
                                )}

                            </React.Fragment>

                        ))}

                        {Object.keys(permisosAgrupadosFiltrados).length === 0 && (

                            <TableRow>

                                <TableCell
                                    colSpan={5}
                                    align="center"
                                >
                                    No se encontraron permisos.
                                </TableCell>

                            </TableRow>

                        )}

                    </TableBody>

                </Table>

                <Menu
                    anchorEl={menuAnchorEl}
                    open={Boolean(menuAnchorEl)}
                    onClose={handleCloseMenu}
                >

                    <MenuItem onClick={handleEditar}>
                        <ListItemIcon>
                            <EditIcon fontSize="small" />
                        </ListItemIcon>

                        <ListItemText>
                            Editar
                        </ListItemText>
                    </MenuItem>

                    <MenuItem
                        sx={{ color: "error.main" }}
                        onClick={handleEliminar}
                    >
                        <ListItemIcon>
                            <DeleteIcon
                                color="error"
                                fontSize="small"
                            />
                        </ListItemIcon>

                        <ListItemText
                            primary="Eliminar"
                            primaryTypographyProps={{
                                color: "error",
                            }}
                        />
                    </MenuItem>

                </Menu>
            </TableContainer>
            {/* MODALES */}
            <AddAdminPermiso
                open={openAddPermiso}
                onClose={handleCloseAddPermiso}
                onSuccess={handlePermisoCreated}
            />

            <UpdateAdminPermiso
                open={openUpdatePermiso}
                onClose={handleCloseUpdatePermiso}
                onSuccess={handlePermisoUpdated}
                permiso={selectedPermiso}
            />

            <DeleteAdminPermiso
                open={openDeletePermiso}
                onClose={handleCloseDeletePermiso}
                onSuccess={handlePermisoDeleted}
                permiso={selectedPermiso}
            />
            
        </Box>
    );
}